// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-subscription-config-container {
  display: flex;
  margin-right: 30px;
}
.manage-subscription-config-container .manage-subscription-config-flex {
  display: flex;
}
.manage-subscription-config-container .manage-subscription-config-add-seats {
  display: flex;
  padding: 20px;
  border: solid 2px #0084ff;
  border-radius: 12px;
  justify-content: space-between;
  width: 322px;
}
.manage-subscription-config-container .manage-subscription-config-row {
  display: flex;
  flex-direction: row;
  flex: 1 1;
}
.manage-subscription-config-container .manage-subscription-config-row-reverse {
  display: flex;
  flex-direction: row-reverse;
  flex: 1 1;
}
.manage-subscription-config-container .manage-subscription-config-column {
  display: flex;
  flex-direction: column;
}
.manage-subscription-config-container .manage-subscription-config-billing {
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: -0.01em;
  text-align: center;
  margin-top: 20px;
}
.manage-subscription-config-container .manage-subscription-config-edit-billing {
  margin-top: 10px;
  background-color: #0084ff;
  color: #fff;
  border: 1px solid #0084ff;
  height: 48px;
  padding: 12px 24px 12px 24px;
  border-radius: 12px;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
}
.manage-subscription-config-container .manage-subscription-config-change-plan {
  margin-top: 10px;
  background-color: #8E55EA;
  color: #fff;
  border: 1px solid #8E55EA;
  height: 48px;
  padding: 12px 24px 12px 24px;
  border-radius: 12px;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
}
.manage-subscription-config-container .manage-subscription-config-buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.manage-subscription-config-container .manage-subscription-config-add-seats-text {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
}
.manage-subscription-config-container .manage-subscription-config-add-seats-button {
  margin-top: 10px;
  height: 48px;
  padding: 12px 24px 12px 24px;
  border-radius: 12px;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
}
.manage-subscription-config-container .manage-subscription-config-next-billing-cycle {
  display: flex;
  flex-direction: row-reverse;
  margin: 20px 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.02em;
  text-align: right;
  color: rgba(108, 114, 117, 0.5);
}
.manage-subscription-config-container .manage-subscription-config-cancel-subscription {
  margin-top: 10px;
  background-color: transparent;
  color: #d84c10;
  border: none !important;
  padding: 0 !important;
  border-radius: 12px;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
}

.line-buttons {
  display: flex;
  flex-direction: row;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Components/ManageSubscriptionConfig/managesubscriptionconfig.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,aAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADJ;AAIE;EACE,aAAA;EACA,2BAAA;EACA,SAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AALJ;AAQE;EACE,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAPJ;AAUE;EAEE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AATJ;AAYE;EACE,gBAAA;EAEA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,QAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAZJ;AAeE;EACE,aAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,+BAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAfF","sourcesContent":[".manage-subscription-config-container {\n  display: flex;\n  margin-right: 30px;\n\n  .manage-subscription-config-flex {\n    display: flex;\n  }\n\n  .manage-subscription-config-add-seats {\n    display: flex;\n    padding: 20px;\n    border: solid 2px #0084ff;\n    border-radius: 12px;\n    justify-content: space-between;\n    width: 322px;\n  }\n\n  .manage-subscription-config-row {\n    display: flex;\n    flex-direction: row;\n    flex: 1;\n  }\n\n  .manage-subscription-config-row-reverse {\n    display: flex;\n    flex-direction: row-reverse;\n    flex: 1;\n  }\n\n  .manage-subscription-config-column {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .manage-subscription-config-billing {\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 40px;\n    letter-spacing: -0.01em;\n    text-align: center;\n    margin-top: 20px;\n  }\n\n  .manage-subscription-config-edit-billing {\n    margin-top: 10px;\n    background-color: #0084ff;\n    color: #fff;\n    border: 1px solid #0084ff;\n    height: 48px;\n    padding: 12px 24px 12px 24px;\n    border-radius: 12px;\n    gap: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n  }\n\n  .manage-subscription-config-change-plan {\n    margin-top: 10px;\n    background-color: #8E55EA;\n    color: #fff;\n    border: 1px solid #8E55EA;\n    height: 48px;\n    padding: 12px 24px 12px 24px;\n    border-radius: 12px;\n    gap: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n  }\n\n  .manage-subscription-config-buttons {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n\n  .manage-subscription-config-add-seats-text {\n    //styleName: Base 1 (Semibold);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n    text-align: left;\n  }\n\n  .manage-subscription-config-add-seats-button {\n    margin-top: 10px;\n\n    height: 48px;\n    padding: 12px 24px 12px 24px;\n    border-radius: 12px;\n    gap: 8px;\n\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n  }\n\n  .manage-subscription-config-next-billing-cycle {\n    display: flex;\n    flex-direction: row-reverse;\n    margin: 20px 0;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: -0.02em;\n    text-align: right;\n    color: rgba(108, 114, 117, 0.5);\n  }\n\n  .manage-subscription-config-cancel-subscription {\n    margin-top: 10px;\n    background-color: transparent;\n    color: #d84c10;\n    border: none !important;\n    padding: 0 !important;\n    border-radius: 12px;\n    gap: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n  }\n}\n\n.line-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
